<!-- 产品管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex flexJc-sb flexAi-c  pad">
        <div class="text">图片列表</div>
        <el-button @click="addImgBut" round type="primary" size="mini"
          >添加图片</el-button
        >
      </div>
      <div class="content">
        <el-table
          height="68vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="BannerList.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="#" width="110"> </el-table-column>
          <el-table-column prop="bannername" label="产品"> </el-table-column>
          <el-table-column label="产品图片" class="certificateImg">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.bannerimg === ''"
                style="width: 100px; height: 100px"
                src="/"
              >
              </el-image>
              <el-image
                v-else
                style="width: 120px; height: 60px"
                :src="baseImage + scope.row.bannerimg"
                :preview-src-list="[baseImage + scope.row.bannerimg]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="分类">
            <template slot-scope="scope">
              {{ scope.row.place | filterBanner }}
            </template>
          </el-table-column>
          <el-table-column label="路由">
            <template slot-scope="scope">
              {{ scope.row.url }}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              {{ scope.row.status | filterNum('可用', '不可应') }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                class="padR10"
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >修改</el-link
              >
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex" v-if="BannerList !== ''">
          <div class="text">
            <span>共{{ BannerList.total }}条记录，</span>
            <span class="pageNum">{{ BannerList.pageNum }}</span>
            <span>/{{ BannerList.pages }}页</span>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="BannerList.pageNum"
            :page-size="BannerList.pageSize"
            layout="prev, pager, next, jumper"
            :total="BannerList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetBBannerList, apiDelBBannerList } from '@/api/InfoUpload'

export default {
  name: '',
  props: [''],
  data() {
    return {
      BannerList: '',
      pages: {
        pageNum: 1,
        pageSize: 20
      } // 页数
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetBBannerList()
  },

  methods: {
    // 添加图片
    addImgBut() {
      this.$router.push({
        path: '/AddImg'
      })
    },
    // 列表删除
    delBut(row) {
      console.log(row)
      apiDelBBannerList({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetBBannerList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 列表修改
    editBut(row) {
      this.$router.push({
        path: '/AddImg',
        query: {
          info: this.$Base64.encode(JSON.stringify(row))
        }
      })
    },

    // 分页
    handleCurrentChange(val) {
      this.pages.pageNum = val
      console.log(`当前页: ${val}`)
      this.GetBBannerList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    // 接口
    // 获取banner列表
    GetBBannerList() {
      apiGetBBannerList({
        page: this.pages.pageNum,
        pageSize: this.pages.pageSize
      }).then(res => {
        if (res.status === 0) {
          this.BannerList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      color: #119685;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // 产品介绍
    /deep/ .introduce {
      display: -webkit-box !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 3 !important;
      overflow: hidden !important;
      color: #9e9e9e;
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    // 分页
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
</style>
